import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PlatformType } from 'src/environments/platform-type.enum';

@Component({
    selector: 'app-icon-dashboard',
    templateUrl: './icon-dashboard.component.html',
    styleUrls: ['./icon-dashboard.component.scss']
})
export class IconDashboardComponent implements OnInit {

    @Input() cssClass = '';

    currentPlatform = environment.platformId;
    PlatformType = PlatformType;

    constructor() { }

    ngOnInit() {
    }

}
